import script from "./ModalSlot.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSlot.vue?vue&type=script&setup=true&lang=js"

import "./ModalSlot.vue?vue&type=style&index=0&id=1b36591f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b36591f"]])

export default __exports__